<script lang="ts" setup>
import { defineProps } from "vue";

const props = defineProps<{
  label: string;
  value: string;
  checked: boolean;
  renderKey?: any;
}>();
</script>

<template>
  <div :key="props.renderKey" class="px-checkbox">
    <input :id="props.value" type="checkbox" :checked="props.checked" />
    <label :for="props.value" v-html="props.label" />
  </div>
</template>

<style lang="scss">
.px-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  cursor: pointer;

  label {
    color: #8b8fa1 !important;
    cursor: pointer;
  }

  mark {
    background-color: #2873cb;
    color: #fff;
  }
}
</style>
